/* eslint-disable multiline-ternary */
import React from 'react'
import { View, Text, Font, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'

const BoxRight = ({
  value,
  index,
  width,
  textAlign,
  title,
  color,
  objectiveMet,
  reportTickImgDataUrl
}) => {
  const borderTop = { borderTop: '1 solid grey' }
  const boxRight = {
    backgroundColor: objectiveMet ? themeConfig.semcogBlue1 : 'transparent',
    width,
    borderRight: '1 solid grey',
    borderBottom: '1 solid grey',
    padding: '5pt',
    display: 'flex',
    justifyContent: 'center',
    fontSize: 11,
    textAlign,
    textTransform: 'capitalize',
    color: objectiveMet ? 'white' : color || 'black',
    fontFamily: 'Roboto'
  }

  return (
    <View
      style={index === 0 ? [boxRight, borderTop, title] : [boxRight, title]}
      wrap={false}
    >
      {objectiveMet && reportTickImgDataUrl ? (
        <Image
          src={reportTickImgDataUrl}
          style={{ height: 20, width: 20, alignSelf: 'center' }}
        />
      ) : (
        <Text>{value}</Text>
      )}
    </View>
  )
}
export default BoxRight

BoxRight.propTypes = {
  title: PropTypes.string,
  width: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.Image]),
  index: PropTypes.number,
  textAlign: PropTypes.string,
  color: PropTypes.string,
  objectiveMet: PropTypes.bool,
  reportTickImgDataUrl: PropTypes.string
}
